var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 58.6666H10.6667C9.25219 58.6666 7.89563 58.1047 6.89544 57.1045C5.89525 56.1044 5.33334 54.7478 5.33334 53.3333V34.6666C5.33334 33.2522 5.89525 31.8956 6.89544 30.8954C7.89563 29.8952 9.25219 29.3333 10.6667 29.3333H18.6667M37.3333 24V13.3333C37.3333 11.2116 36.4905 9.17675 34.9902 7.67646C33.4899 6.17617 31.4551 5.33331 29.3333 5.33331L18.6667 29.3333V58.6666H48.7467C50.0329 58.6812 51.281 58.2304 52.2611 57.3973C53.2412 56.5643 53.8872 55.4051 54.08 54.1333L57.76 30.1333C57.876 29.3689 57.8245 28.5885 57.6089 27.846C57.3934 27.1035 57.019 26.4168 56.5116 25.8334C56.0043 25.2499 55.3762 24.7838 54.6709 24.4672C53.9655 24.1507 53.1998 23.9912 52.4267 24H37.3333Z",
    stroke: "#FB1A50",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.cbd8de65352bc4f2a69212cbda0d63d6.svg";
export { ForwardRef as ReactComponent };